import { render, staticRenderFns } from "./CustomerReviews.vue?vue&type=template&id=73c5ed38&scoped=true"
import script from "./CustomerReviews.vue?vue&type=script&lang=js"
export * from "./CustomerReviews.vue?vue&type=script&lang=js"
import style0 from "./CustomerReviews.vue?vue&type=style&index=0&id=73c5ed38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c5ed38",
  null
  
)

export default component.exports